/* eslint-disable no-shadow */
const state = {
    bookingDetails: {
        location: {},
        service: {},
        event: {},
        schedulingDateAndTime: {},
        teamMember: {}
    },
    componentKey: 0,
    step: 0,
    globalDateForDatePicker: null,
    stepData : {
        location: '',
        service: '',
        schedulingDateAndTime: '',
        teamMember: '',
        event: ''
    }
};

const mutations = {
    incrementComponent(state) {
        state.componentKey += 1;
    },
    addBookingDetails(state, payload) {
        state.bookingDetails[payload.type] = payload.details;
    },
    nextStep(state) {
        state.step++;
    },
    prevStep(state) {
        state.step--;
        if (state.step < 0) {
            state.step = 0;
        }
    },
    setGlobalDateForDatePicker(state, payload) {
        state.globalDateForDatePicker = payload;
    },
    setStepData(state, payload) {
        if (state.stepData[payload.name] !== undefined && payload.value !== undefined) {
            state.stepData[payload.name] = payload.value;
        }
    }
};

const getters = {
    bookingDetails: state => state.bookingDetails,
    eventLocation: state => {
        if (Object.keys(state.bookingDetails.service).length > 0) {
            return state.bookingDetails.service.eventLocation;
        } else if (Object.keys(state.bookingDetails.event).length > 0) {
            return state.bookingDetails.event.eventLocation;
        } else {
            return null;
        }
    },
    nextEvent: state => {
        if (state.bookingDetails.service) {
            return state.bookingDetails.service.nextEvent;
        } else if (state.bookingDetails.event) {
            return state.bookingDetails.event.nextEvent;
        } else {
            return null;
        }
    }
};

const actions = {
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
